import React from "react";
import { useOpenTicket } from "../hooks/useOpenTicket";
import moment from "moment";
import { useAuth } from "../context/AuthContext";
import { addInterventionsTicket } from "../lib/ticket";
import { FaUnlock } from "react-icons/fa";
import { getDisplayTitle } from "../utils/titleformat";

const OpenTicketModal = ({ ticket, onClose, onSubmitSuccess, onError }) => {
  const { openTicket, loading } = useOpenTicket();
  const { userInfo } = useAuth();

  const handleOpenTicket = async (e) => {
    e.preventDefault();
    const form = e.target;
    const success = await openTicket(ticket.idTicket);

    const now = moment().format("YYYY-MM-DD HH:mm:ss");
    const intervention = {
      utilisateur: 1013,
      description: `OUVERT par ${userInfo?.userName}: ${form.descriptionTicketAdd.value}`,
      date_debut: now,
      duree: 1,
    };
    await addInterventionsTicket(ticket.idTicket, intervention);

    if (success) {
      onClose();
      onSubmitSuccess();
    } else {
      onError();
    }
  };

  return (
    <>
      <div className="modal-backdrop fade show" />
      <div className="modal fade show d-block modal-overlay" role="dialog" aria-modal="true" onClick={onClose}>
        <div className="modal-dialog modal-dialog-centered" onClick={e => e.stopPropagation()}>
          <div className="modal-content shadow-lg">
            <form onSubmit={handleOpenTicket}>
              <div className="modal-header bg-light border-bottom">
                <div>
                  <h5 className="modal-title font-weight-bold">
                    <FaUnlock className="me-2 text-success" />
                    Réouverture du ticket
                  </h5>
                  <small className="text-muted">{getDisplayTitle(ticket?.titre)}</small>
                </div>
                <button type="button" className="btn-close" onClick={onClose} aria-label="Fermer" />
              </div>

              <div className="modal-body">
                <div className="form-group mb-0">
                  <label className="font-weight-semibold">
                    Message <span className="text-danger">*</span>
                  </label>
                  <textarea
                    className="form-control"
                    name="descriptionTicketAdd"
                    rows={5}
                    placeholder="Motif de réouverture..."
                    required
                  />
                </div>
              </div>

              <div className="modal-footer bg-light border-top">
                <button type="button" className="btn btn-secondary" onClick={onClose}>
                  Annuler
                </button>
                <button
                  type="submit"
                  className="btn btn-success"
                  disabled={loading}
                  data-testid="open-ticket-button-modal"
                >
                  {loading ? "Envoi..." : "Rouvrir le ticket"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};
export default OpenTicketModal;
